import Button from '~/components/Buttons/Button'
import { ButtonProps } from '~/components/Buttons/types'
import { useAppSelector } from '~/redux/hooks'

import { selectVideoTopicColor } from '~/bootcamp/slices/vcc-data.slice'

const ActivityAnswerButton = ({ className = '', children, ...props }: ButtonProps): React.ReactElement => {
  const colorInfo = useAppSelector(selectVideoTopicColor)

  return (
    <Button className="active:transform-none outline-0 focus:outline-0 group" noPadding {...props} type="submit">
      <span
        className={`min-h-9 py-1.5 flex justify-center items-center text-md rounded font-medium ${colorInfo.bgClass} lg:group-disabled:${colorInfo.bgClass} ${colorInfo.ringClass} lg:group-hover:bg-purple-dark group-focus:bg-purple-focus group-hover:ring-purple-dark lg:group-focus:ring-purple-light transition transform scale-100 group-active:scale-95 ${className}`}
      >
        {children}
      </span>
    </Button>
  )
}

export default ActivityAnswerButton
